// test2292
(2292 && 0);
